import axios from "axios";

declare global {
  interface Window {
    ope(
      name: string,
      functionName: "send",
      eventName: string,
      parameters: Record<string, unknown>,
    ): void;
    ope(
      name: string,
      functionName: "onProfile",
      callbackFunction: (error: Error, data: { s: string[]; t: string[] }) => void,
    ): void;
    ope(
      name: string,
      functionName: "sendVisit",
      parameters: {
        visiturl: string;
      },
    ): void;
  }
}

export async function fetchRealtimeProfile() {
  if (window.ope === undefined) return;
  return new Promise<RealtimeProfile>((resolve, reject) => {
    window.ope?.("scmp", "onProfile", (error, data) => {
      if (error) reject({ audienceSegmentIds: [], topicIds: [] });
      else resolve({ audienceSegmentIds: data.s, topicIds: data.t });
    });
  });
  type RealtimeProfile = { audienceSegmentIds: string[]; topicIds: string[] };
}

export async function fetchUserAudienceId() {
  const response = await axios.get<Response>("https://tagger.ope.scmp.com/scmp/v2/uid", {
    withCredentials: true,
  });

  if (!response.data) return;
  return {
    part0: response.data["part-0"],
    part1: response.data["part-1"],
  };

  type Response = { "part-0": string; "part-1": string };
}
